import { logger } from "../App";
import axiosBase from "./axiosBase";
import coreConfig from "./coreConfig";

export const isAuthenticated = async () => {
    try {
        const res = await axiosBase({
            api: coreConfig.apiConfig.endpoints.login,
            method: coreConfig.apiConfig.reqMethod.GET
        });
        if (res?.status === 200) {
            return res?.data;
        }
        return false;
    } catch (error) {
        logger({ error, message: "Error fetching data" });
        return false;
    }
};

export const logout = async () => {
    const res = await axiosBase({
        api: coreConfig.apiConfig.endpoints.logout,
        method: coreConfig.apiConfig.reqMethod.POST
    });
    localStorage.clear();
    if (res.status === 200) {
        window.location.href = '/login?isLogout=true';
    };
};